import { InferenceResult } from './InferenceResult';
import { InferenceAdditionalResult } from './InferenceAdditionalResult';

/**
 * 観察簿データ
 */
export class KansatsuKiroku {
  koujiBangou: string;
  key: string;
  kansatsuDate: string; // 観察年月日(YYYY-MM-DD)
  sokutenNumber: string; // 測点No
  danmenNumber: string; // 断面番号
  kyori: string; // 坑口からの距離
  kansatsuDateMemo: string; // 観察年月日(YYYY-MM-DD)
  sokutenNumberMemo: string; // 測点No
  danmenNumberMemo: string; // 断面番号
  kyoriMemo: string; // 坑口からの距離
  inferenceResultJsonStr: string; // 推論結果のJSONの文字列表現
  inferenceAdditionalResultJsonStr: string; // 推論結果追加情報のJSONの文字列表現
  inferenceResult: InferenceResult[];
  inferenceAdditionalResult: InferenceAdditionalResult;
  inferenceId: string;
  croppedImageBucket: string; // 切り抜き済み画像格納Bucket
  croppedImageKey: string; // 切り抜き済み画像格納key
  originalImageBucket: string; // オリジナル画像格納Bucket
  originalImageKey: string; // オリジナル画像格納key
  croppedImageSignedUrl: string;
  // 自由入力欄
  freeInputs: Array<{
    title: string;
    value: string;
    memo: string;
  }>
  freeInputsJsonStr: string;
  createdAt: string; // 作成日時
  lastModifiedAt: string; // 最終更新日時
  deletedAt: string; // 削除日時
  downloadFileStatus: string;
  downloadFileBucket: string;
  downloadFileKey: string;
  downloadFileCreationDatetime: string; // ダウンロードファイルの作成日時 YYYY-MM-DDThh:mm:ss+0900
  downloadFileUrl: string; // ダウンロードファイルのSignedURL
}



// WEBPACK FOOTER //
// ./src/models/KansatsuKiroku.ts